import { IShift } from './shifts.service';
import { BaseEntity } from '../base/base.entity';
import { AppService } from '../main/app.service';
import { BaseService } from '../base/base.service';


export class ICalendarShift extends BaseEntity {
    start: string;
    end: string;
    status: string;
    title: string;
    shift: IShift;
    statusColor: string;
}


export class CalendarService extends BaseService<ICalendarShift> {
 
    constructor(protected Restangular: Restangular.IService, protected AppService: AppService) {
        "ngInject";
        super(Restangular, AppService, 'calendar');
    }

    public all = (params): ng.IPromise<ICalendarShift[]> => {
        
        return this.Restangular.all('calendar').customGET('', params).then((response: Restangular.ICollection) => {
            this.list = response.plain();
            return this.listLoaded(this.list);
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/services/calendar.service.ts